export function selectRegistrationRequest(state) {
  const invitation = state.GlobalReducer?.invitation;
  const registrationInfo = state.GlobalReducer?.registrationInfo;
  let request = { name: invitation.fullName, phone: registrationInfo.phone, email: invitation.email, password: registrationInfo.password, invitationId: invitation.id, hospital: invitation.hospital };

  return request;
}

export function selectPasswordResetToken(state) {
  return state?.GlobalReducer?.passwordResetToken;
}

export function selectRole(state) {
  return state?.GlobalReducer?.invitation?.role;
}

export function selectCountry(state) {
  return state?.GlobalReducer?.invitation?.country || 'BG';
}
